import { generateToDocFn } from '@dadohr/shared/domainTypes/document';
import { AiUsageCurrent, AiUsageHistory } from '@dadohr/shared/domainTypes/aiUsage';
import { refreshTimestamp } from '../firebase';

export const toAiUsageCurrentDoc = generateToDocFn<AiUsageCurrent>((d) => {
  d.organizationId = d.organizationId || '';
  d.periodType = d.periodType || 'monthly';
  d.inputTokens = d.inputTokens || 0;
  d.outputTokens = d.outputTokens || 0;
  d.totalTokens = d.totalTokens || 0;
  d.requestCount = d.requestCount || 0;
  d.periodStart = refreshTimestamp(d.periodStart);
  d.periodEnd = refreshTimestamp(d.periodEnd);
  d.createdAt = refreshTimestamp(d.createdAt);
  d.updatedAt = refreshTimestamp(d.updatedAt);
  return d;
});

export const toAiUsageHistoryDoc = generateToDocFn<AiUsageHistory>((d) => {
  d.organizationId = d.organizationId || '';
  d.periodType = d.periodType || 'monthly';
  d.inputTokens = d.inputTokens || 0;
  d.outputTokens = d.outputTokens || 0;
  d.totalTokens = d.totalTokens || 0;
  d.requestCount = d.requestCount || 0;
  d.periodStart = refreshTimestamp(d.periodStart);
  d.periodEnd = refreshTimestamp(d.periodEnd);
  d.createdAt = refreshTimestamp(d.createdAt);
  d.updatedAt = refreshTimestamp(d.updatedAt);
  return d;
});
